import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const Row = styled.div`
  display: flex;
  padding: 10px;
  margin-bottom: 2px;
  background: ${props => props.theme.fav.rowBg};
  &:last-child {
    margin-bottom: 0;
  }
  color: #fff;
`;

const FavRow = ({ theme, exchange: { id, name }, selectExchange }) => (
  <ThemeProvider theme={theme}>
    <Row>
      <div id={id} onClick={selectExchange}>
        {name}
      </div>
    </Row>
  </ThemeProvider>
);

export default withTheme(FavRow);



// WEBPACK FOOTER //
// ./src/components/FavExRow.js